import { render, staticRenderFns } from "./PlanSelectionV3.vue?vue&type=template&id=b8d5d6a2&"
import script from "./PlanSelectionV3.vue?vue&type=script&lang=js&"
export * from "./PlanSelectionV3.vue?vue&type=script&lang=js&"
import style0 from "./PlanSelectionV3.vue?vue&type=style&index=0&id=b8d5d6a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports